module.exports = "<div id=\"terms_Conditions\">\r\n    <h1>Terms & Conditions</h1>\r\n    <div class=\"terms\" #terms></div>\r\n    <div class=\"getTerms\">\r\n        <mat-checkbox #checkbox [checked]='CHECKED' (change)='OnCheckBoxClick(checkbox)'>By checking this box you are agreeing to the Terms and Conditions</mat-checkbox>\r\n        <label for='getterms'></label>\r\n\r\n    </div>"


//////////////////
// WEBPACK FOOTER
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/terms/terms.component.html
// module id = 8rQh
// module chunks = 7